import { tokens } from '../tokens'

export const ja = {
    [tokens.common.total]: '全体',
    [tokens.common.choose_center]: 'センター選択',
    [tokens.common.fail]: '失敗',
    [tokens.common.barcode_scan]: 'バーコードスキャン',
    [tokens.common.accept]: '確認',
    [tokens.common.cancel]: 'キャンセル',
    [tokens.common.choose]: '選択',
    [tokens.common.shelf_over_limit]: '賞味期限超過間近',
    [tokens.common.damaged_goods]: '商品破損',
    [tokens.common.defected_goods]: '商品不良',
    [tokens.common.select_reason_for_return]: '返品理由選択',
    [tokens.common.please_enter_detailed_reason_for_return]: '返品理由を詳しく入力してください',
    [tokens.common.close]: '閉じる',
    [tokens.common.complete]: '完了',
    [tokens.common.success]: '成功',
    [tokens.common.return_to_the_purchase]: '仕入先返品',
    [tokens.common.reception_details]: '受付内訳',
    [tokens.common.list_of_recovery_codes]: '回収コード一覧',
    [tokens.common.please_enter_the_product_name_or_barcode]: '商品名、請求書番号、商品バーコードを入力してください',
    [tokens.common.total_sum]: '総',
    [tokens.common.confirmation_of_arrival_processing]: '入荷処理確認',
    [tokens.common.add_item]: '項目追加',
    [tokens.common.remove_item_]: '項目削除',
    [tokens.common.remove_item]: '項目削除',
    [tokens.common.modify_entry_processing]: '入荷処理修正',
    [tokens.common.complete_entry_processing]: '入荷処理完了',
    [tokens.common.entry_processing]: '入荷処理',
    [tokens.common.order_form_temperature]: '発注書品温',
    [tokens.common.center_selection_is_required]: 'センター選択は必須です',
    [tokens.common.cannot_move_to_the_same_center]: '同じセンターにセンター移動できません',
    [tokens.common.quantity_to_be_moved_must_be_entered]: '移動数量は必須入力です',
    [tokens.common.please_enter_the_minimum_move_quantity_above]: '最小移動数量は以上で入力してください',
    [tokens.common.entered_movement_quantity_is_the_available_movement_quantity]: '入力した移動数量が移動可能数量',
    [tokens.common.there_are_more]: 'より多いです',
    [tokens.common.move_center]: 'センター移動',
    [tokens.common.quantity_of_goods]: '商品の数量',
    [tokens.common.count_move_center]: '個をセンター移動しますか',
    [tokens.common.please_enter_the_quantity_to_move]: '移動する数量を入力してください',
    [tokens.common.product_inquiry]: '商品照会',
    [tokens.common.add_zone]: '区域追加',
    [tokens.common.product_details]: '商品詳細',
    [tokens.common.movement_quantity_is_required]: '移動数量は必須入力です',
    [tokens.common.enter_the_minimum_movement_quantity_above]: '最小移動数量は以上で入力してください',
    [tokens.common.would_you_count_move_center]: '個別に移動しますか',
    [tokens.common.select_return_type]: '返品タイプ選択',
    [tokens.common.select_return_type_is_required]: '返品タイプ選択は必須です',
    [tokens.common.please_enter_the_required_return_quantity]: '返品数量は必須入力です',
    [tokens.common.please_enter_the_minimum_return_quantity_above]: '最小返品数量は以上で入力してください',
    [tokens.common.returned_quantity_entered_is_the_returnable_quatity]: '入力した返品数量が返品可能数量',
    [tokens.common.refund_reason_input_is_required]: '返品理由入力は必須です',
    [tokens.common.maximum_input]: '最大入力',
    [tokens.common.entered_more_than_allowed]: 'より多く入力しました',
    [tokens.common.supplier_return]: '仕入先返品',
    [tokens.common.will_you_process_the_return_of_items]: '個別に返品処理しますか',
    [tokens.common.please_enter_the_quantity_to_return]: '返品する数量を入力してください',
    [tokens.common.please_enter_the_return_reason]: '返品理由を入力してください',
    [tokens.common.select_adjustment_type]: '調整タイプ選択',
    [tokens.common.selecting_adjustment_type_is_required]: '調整タイプ選択は必須です',
    [tokens.common.please_enter_adjustment_quantity]: '調整数量は必須入力です',
    [tokens.common.please_enter_minimum_adjustment_quantity_or_more]: '最小調整数量は以上で入力してください',
    [tokens.common.input_adjustment_quantity_is_adjustable_quantity]: '入力した調整数量が調整可能数量',
    [tokens.common.inputting_expiration_date_is_required_when_adjusting_expiration_date]: '賞味期限調整時、賞味期限入力は必須です',
    [tokens.common.are_you_really_adjusting_the_expiration_date_for_this_reason]: '理由で賞味期限を調整します。本当に調整しますか',
    [tokens.common.are_you_really_adjusting_the_stock_quantity_for_this_reason]: '理由で在庫数量を増減します。本当に調整しますか',
    [tokens.common.are_you_really_adjusting_the_stock_quantity_down_for_this_reason]: '理由で在庫数量を減少します。本当に調整しますか',
    [tokens.common.adjustment]: '調整',
    [tokens.common.please_enter_the_quantity_to_adjust]: '調整する数量を入力してください',
    [tokens.common.interwarehouse_transfer]: '倉庫間移動',
    [tokens.common.row]: '列',
    [tokens.common.layer]: '段',
    [tokens.common.inventory_transfer_cancellation]: '在庫移動キャンセル',
    [tokens.common.enter_location_code_or_scan_barcode]: 'ロケーションコード入力またはバーコードスキャン',
    [tokens.common.inventory_movement_cancellation]: '在庫移動キャンセル',
    [tokens.common.replenishment_quantity_is_required]: '補充数量は必須です',
    [tokens.common.please_enter_the_quantity_to_replenish]: '補充する数量を入力してください',
    [tokens.common.inventory_replenishment_scan]: '在庫補充スキャン',
    [tokens.common.scan_departure_barcode]: '出発地バーコードスキャン',
    [tokens.common.please_scan_the_barcode]: 'バーコードをスキャンしてください',
    [tokens.common.scan_arrival_barcode]: '到着地バーコードスキャン',
    [tokens.common.inventory_replenishment_has_been_processed]: '在庫補充が処理されました',
    [tokens.common.scan_departure_location]: '出発地ロケーションスキャン',
    [tokens.common.scan_arrival_location]: '到着地ロケーションスキャン',
    [tokens.common.enter_investigation_quantity]: '調査数量入力',
    [tokens.common.please_enter_expiration_date_and_quantity]: '賞味期限と数量を入力してください',
    [tokens.common.inventory_investigation_processing_completed]: '在庫調査が完了しました',
    [tokens.common.quantity]: '数量',
    [tokens.common.add]: '追加',
    [tokens.common.today]: '今日',
    [tokens.common.initialize]: '初期化',
    [tokens.common.disposal_schedule_inquiry]: '廃棄予定照会',
    [tokens.common.enter_zone_name]: '区域名入力',
    [tokens.common.select_zone]: '区域選択',
    [tokens.common.common_password_is_required]: '共通パスワードは必須です',
    [tokens.common.passwords_do_not_match]: 'パスワードが一致しません',
    [tokens.common.edit]: '修正',
    [tokens.common.additional_registration]: '追加登録',
    [tokens.common.notification]: '通知',
    [tokens.common.zone]: '区域',
    [tokens.common.save]: '保存',
    [tokens.common.register]: '登録',
    [tokens.common.anpyeong]: '安平',
    [tokens.common.lee_hun_ju]: 'イ・ホンジュ',
    [tokens.common.local_line]: 'ローカル線',
    [tokens.common.search]: '検索',
    [tokens.common.please_enter_search_term]: '検索ワードを入力してください',
    [tokens.common.no_records_found]: '照会された内訳がありません',
    [tokens.common.customer_code]: '取引先コード',
    [tokens.common.contract_status]: '契約状態',
    [tokens.common.contract_date]: '契約日',
    [tokens.common.end_date]: '終了日',
    [tokens.common.customer_name]: '取引先名',
    [tokens.common.brand]: 'ブランド',
    [tokens.common.designate]: '指定',
    [tokens.common.please_enter_id]: 'IDを入力してください',
    [tokens.common.please_enter_password]: 'パスワードを入力してください',
    [tokens.common.please_enter_product_or_product_name]: '商品または商品名を入力してください',
    [tokens.common.please_enter_product_info]: '商品ID、商品名、商品バーコードを入力してください',
    [tokens.common.incoming_schedule_details]: '入庫予定詳細',
    [tokens.common.receive_modification]: '入荷修正',
    [tokens.common.incoming_schedule_list]: '入庫予定一覧',
    [tokens.common.stored_inventory]: '保管在庫',
    [tokens.common.daily_inventory]: '日在庫',
    [tokens.common.inventory_replenishment_details]: '在庫補充詳細',
    [tokens.common.inventory_replenishment_cancellation]: '在庫補充キャンセル',
    [tokens.common.replenishment_cancellation]: '補充キャンセル',
    [tokens.common.inventory_replenishment_list]: '在庫補充一覧',
    [tokens.common.inventory_audit]: '在庫調査',
    [tokens.common.inventory_investigation]: '在庫調査',
    [tokens.common.in_progress]: '進行中',
    [tokens.common.no_inquiry_information_found]: '照会情報がありません',
    [tokens.common.item_count]: '個',
    [tokens.common.purpose]: '用途',
    [tokens.common.temperature]: '温度',
    [tokens.common.option]: 'オプション',
    [tokens.common.individual_picking]: '個別ピッキング',
    [tokens.common.please_scan_midmile_label_barcode]: '幹線のラベルバーコードをスキャンしてください',
    [tokens.common.loading_inspection_completed]: '積載検収完了',
    [tokens.common.loading_inspection_pending]: '積載検収待機',
    [tokens.common.please_scan_product_label_barcode]: '商品ラベルバーコードをスキャンしてください',
    [tokens.common.please_scan_total_picking_barcode]: 'トータルピッキングバーコードをスキャンしてください',
    [tokens.common.please_scan_individual_picking_barcode]: '個別ピッキングバーコードをスキャンしてください',
    [tokens.common.unable_to_connect_to_server_please_try_again_later]: 'サーバーと接続できません。しばらくしてからもう一度お試しください',
    [tokens.common.if_you_leave_the_page_your_work_will_not_be_saved]: 'ページを離れると作業内容が保存されません',
    [tokens.common.normal]: 'ノーマル',
    [tokens.common.date_3]: '日付',
    [tokens.common.hour]: '時間',
    [tokens.common.product_name]: '商品名',
    [tokens.common.product_barcode]: '商品バーコード',
    [tokens.common.product_temperature]: '温度',
    [tokens.common.purchase_name]: '仕入先名',
    [tokens.common.total_plt_count]: '総PLT数',
    [tokens.common.expiration_date]: '賞味期限',
    [tokens.common.expiration_date_input]: '賞味期限 入力',
    [tokens.common.order_unit_count]: '発注単位数量',
    [tokens.common.actual_inbound_count]: '実入庫数量',
    [tokens.common.accumulation_status]: '配置現況',
    [tokens.common.order_unit]: '注文ユニット',
    [tokens.common.complete_arrival_processing]: '入荷処理が完了しました',
    [tokens.common.unit]: '単位',
    [tokens.common.departure]: '出発',
    [tokens.common.arrival]: '到着',
    [tokens.common.purchase_name]: '仕入先',
    [tokens.common.label]: 'ラベル',
    [tokens.common.location_]: '位置',
    [tokens.common.last_modified_datetime]: '最終変更日時',
    [tokens.common.specification]: '規格',
    [tokens.common.sector]: 'セクター',
    [tokens.common.no_loaded_items]: '積載された商品がありません。ご確認ください。',
    [tokens.common.not_placed]: '未配置',
    [tokens.common.actual_inventory]: '実在庫',
    [tokens.common.scheduled_outbound]: '出庫予定',
    [tokens.common.movable]: '移動可能',
    [tokens.common.storage_duration]: '配置期間',
    [tokens.common.day]: '日',
    [tokens.common.product]: '商品',
    [tokens.common.product_info]: '商品情報',
    [tokens.common.remaining]: '残余',
    [tokens.common.partial_cancellation]: '部分キャンセル',
    [tokens.common.is_item]: '商品です',
    [tokens.common.repack_and_rescan_item_qty]: '商品数量を再包装してから再スキャンしてください',
    [tokens.common.order_canceled]: '注文がキャンセルされた',
    [tokens.common.already_scanned]: '既にスキャン処理された',
    [tokens.common.is_logistics_code]: '物流コードです',
    [tokens.common.please_contact_center_admin]: 'センター管理者にお問い合わせください',
    [tokens.common.unsent_logistics_code]: '未出庫状態の物流コードです',
    [tokens.common.logistics_number]: '物流番号が',
    [tokens.common.does_not_exist]: '存在しません',
    [tokens.common.pda_admin_password]: 'PDA管理者パスワード',
    [tokens.common.no_items_to_transfer_to_center]: 'センターに移動する商品の情報がありません',
    [tokens.common.center_transfer_completed]: 'センター移動処理が完了しました',
    [tokens.common.network_error]: 'ネットワークエラー',
    [tokens.common.cannot_connect_server]: 'サーバーに接続できませんでした。後でもう一度お試しください。',
    [tokens.common.lot_no]: 'LOT',
    [tokens.common.lot_no_input]: 'LOT番号入力',
    [tokens.common.invoice_no]: 'INVOICE NO',
    [tokens.common.inbound_expected_significant]: '入庫予定書特異事項',
    [tokens.common.inbound_expected_goods_significant]: '入荷予定商品特記事項',

    [tokens.inbound.incoming_management]: '入庫管理',
    [tokens.inbound.midmile]: '幹線入庫',
    [tokens.inbound.complete_]: '입고 완료',
    [tokens.inbound.complete]: '入庫完了',
    [tokens.inbound.check_the_expected_receipt]: '入庫予定書照会',
    [tokens.inbound.no_information_on_the_expected_receipt_inquiry]: '入庫予定書情報がありません',
    [tokens.inbound.greater_than_expected_quantity_received]: '「入庫予定数量より実入庫数量が多いです。強制入庫処理を進めてください」',
    [tokens.inbound.admission_processing]: '入荷処理',
    [tokens.inbound.inbound_mi_processing]: '未入荷処理',
    [tokens.inbound.inbound_mi_processing_confirm_text]: '未入荷処理をしますか？',
    [tokens.inbound.inbound_mi_processing_success_text]: '未入荷処理を完了しました。',
    [tokens.inbound.inbound_stack]: '入庫適置',
    [tokens.inbound.incoming_confirmation]: '入庫確認',
    [tokens.inbound.midmile_incoming]: '幹線入庫',
    [tokens.inbound.please_scan_midmile_incoming_label_barcode]: '幹線入庫ラベルバーコードをスキャンしてください',
    [tokens.inbound.incoming_waiting]: '入庫待機',
    [tokens.inbound.return_incoming]: '回収入庫',
    [tokens.inbound.please_scan_return_incoming_label_barcode]: '回収入庫ラベルバーコードをスキャンしてください',
    [tokens.inbound.new_incoming]: '新規入庫',
    [tokens.inbound.date_time]: '入庫日時',
    [tokens.inbound.less_then_expted_midlmile_plt_quantity]: `入庫予定のPLT数量より少なくなっています。\n幹線入庫をそのまま進行しますか？`,
    [tokens.inbound.complete_midlmile_inbound]: '幹線入庫完了',
    [tokens.inbound.processing_complete_midlmile_inbound]: '幹線入庫完了処理',
    [tokens.inbound.inbound_center]: '入庫センター',
    [tokens.inbound.receipt_plan_differs_from_info]: '入庫予定書と情報が異なります。\nそれでも入荷処理を進めますか？',
    [tokens.inbound.confirm_receipt_total_info]: '総 {{total}} を入荷処理しますか？',
    [tokens.inbound.no_receipt_data]: '入荷資料がありません。',
    [tokens.inbound.receipt_processing_completed]: '入庫処理が完了しました。',
    [tokens.inbound.placement_qty]: '置き数量',
    [tokens.inbound.view_expected_receipt]: '入庫予定書を見る',
    [tokens.inbound.total_expected_receipt_count]: '総 {{total}} 件の予定書',
    [tokens.inbound.confirm_daily_stock_inbound_complete]: '仕入先の当日在庫商品を入庫完了処理しますか？',
    [tokens.inbound.completed_daily_stock_inbound]: '[日在庫]入庫完了処理がされました。',
    [tokens.inbound.not_a_returned_inbound_item_label_barcode]: '回収入庫商品のラベルバーコードではありません',
    [tokens.inbound.items_for_conversion_to_good_condition]: '良品化が必要なリスト',
    [tokens.inbound.expected_stock_quantity]: '入庫予定数量',
    [tokens.inbound.expected_lot_no]: '入荷予定LOT番号',
    [tokens.inbound.lot_save_success_title]: '商品LOTを保存',
    [tokens.inbound.lot_save_success_text]: '商品LOTの保存が完了しました。',
    [tokens.inbound.lot_save_title]:'商品LOTを保存',
    [tokens.inbound.lot_save_text]: '商品LOTと有効期間を保存しますか？',


    [tokens.outbound.management]: '出庫管理',
    [tokens.outbound.midmile_outgoing]: '幹線出庫',
    [tokens.outbound.outgoing_management]: '出庫管理',
    [tokens.outbound.outgoing_confirmation]: '出庫確認',
    [tokens.outbound.please_sacn_midmile_outbound_label_barcode]: '幹線出庫パレットのラベルバーコードをスキャンしてください。',
    [tokens.outbound.midmile_outgoing_complete]: '幹線出庫完了',
    [tokens.outbound.midmile_outgoing_complete_processing]: '幹線出庫完了処理',
    [tokens.outbound.less_then_expted_midlmile_plt_quantity]: '出庫予定のPLT数量より少なくなっています。\n幹線出庫をそのまま進行しますか？',
    [tokens.outbound.completed_midmile_outgoing]: '幹線出庫および着地センターへの入庫が完了しました。',
    [tokens.outbound.departure_and_arrival]: '出発地/到着地',
    [tokens.outbound.outbounded_at]: '出庫日時',

    [tokens.inventory.limit]: '在庫調査制限',
    [tokens.inventory.quality_improvement]: '良品化',
    [tokens.inventory.dispose]: '廃棄',
    [tokens.inventory.scan_the_location_of_the_quality_product_stack]: '良品化適置ロケーションスキャン',
    [tokens.inventory.scanning_the_staging_location]: '適置ロケーションスキャン',
    [tokens.inventory.location_barcode_error]: 'ロケーションバーコードエラー',
    [tokens.inventory.location_barcode_information_is_incorrect]: 'ロケーションバーコード情報が正しくありません',
    [tokens.inventory.check_location_temperature]: 'ロケーション温度確認',
    [tokens.inventory.is_not_the_location_of]: 'のロケーションではありません',
    [tokens.inventory.check_location_usage]: 'ロケーション用途確認',
    [tokens.inventory.please_process_product_stacking_at_the_picking_storage_location]: '商品適置はピッキング保管ロケーションとして処理してください',
    [tokens.inventory.please_scan_the_location_label_barcode]: 'ロケーションラベルバーコードをスキャンしてください',
    [tokens.inventory.stock_movement]: '在庫移動',
    [tokens.inventory.inventory_adjustment]: '在庫調整',
    [tokens.inventory.location_inquiry]: 'ロケーション照会',
    [tokens.inventory.add_location]: 'ロケーション追加',
    [tokens.inventory.enter_location_name]: 'ロケーション名入力',
    [tokens.inventory.edit_location_information]: 'ロケーション情報修正',
    [tokens.inventory.location_management]: 'ロケーション管理',
    [tokens.inventory.sector]: 'セクター',
    [tokens.inventory.bay]: 'ロケーション',
    [tokens.inventory.rack_row_number]: 'ラック列番号',
    [tokens.inventory.rack_layer_count]: 'ラック段数',
    [tokens.inventory.location_purpose]: 'ロケーション用途',
    [tokens.inventory.location_option]: 'ロケーションオプション',
    [tokens.inventory.location_temperature]: 'ロケーション温度',
    [tokens.inventory.edit_location]: 'ロケーション修正',
    [tokens.inventory.register_location]: 'ロケーション登録',
    [tokens.inventory.add_sector]: 'セクター追加',
    [tokens.inventory.enter_sector_name]: 'セクター名入力',
    [tokens.inventory.select_sector]: 'セクター選択',
    [tokens.inventory.slow_moving_inventory_location]: '不良在庫ロケーション',
    [tokens.inventory.scheduled_disposal_location]: '廃棄予定ロケーション',
    [tokens.inventory.unused_location]: '未使用ロケーション',
    [tokens.inventory.incoming_location]: '入庫ロケーション',
    [tokens.inventory.picking_location]: 'ピッキングロケーション',
    [tokens.inventory.takeback_location]: '回収ロケーション',
    [tokens.inventory.return_location]: '返品ロケーション',
    [tokens.inventory.scheduled_disposal_product_location]: '廃棄予定商品ロケーション',
    [tokens.inventory.receiving_zone_location]: '入庫ゾーンロケーション',
    [tokens.inventory.picking_zone_location]: 'ピッキングゾーンロケーション',
    [tokens.inventory.takeback_zone_location]: '回収ゾーンロケーション',
    [tokens.inventory.return_zone_location]: '返品ゾーンロケーション',
    [tokens.inventory.inventory_inquiry]: '在庫照会',
    [tokens.inventory.location_scan]: 'ロケーションスキャン',
    [tokens.inventory.location_information_not_found]: 'ロケーション情報がありません',
    [tokens.inventory.please_scan_location_barcode]: 'ロケーションバーコードをスキャンしてください',
    [tokens.inventory.location_detail_inquiry]: 'ロケーション詳細照会',
    [tokens.inventory.location_code]: 'ロケーションコード',
    [tokens.inventory.location_alias]: 'ロケーション別名',
    [tokens.inventory.location_detail]: 'ロケーション詳細',
    [tokens.inventory.location_information_inquiry]: 'ロケーション情報照会',
    [tokens.inventory.inquiring_location_information]: 'ロケーション情報を照会する',
    [tokens.inventory.enter_location_label_code_or_scan_barcode]: 'ロケーションラベルコード入力またはバーコードスキャン',
    [tokens.inventory.zone_name]: '区域名',
    [tokens.inventory.sector_name]: 'セクター名',
    [tokens.inventory.bay_name]: 'ベイ名',
    [tokens.inventory.row_number]: '列番号',
    [tokens.inventory.layer_count]: '段数',
    [tokens.inventory.inventory_replenishment]: '在庫補充',
    [tokens.inventory.inventory_management]: '在庫管理',
    [tokens.inventory.inventory_control]: '在庫管理',
    [tokens.inventory.not_exists_location_code]: '存在しないロケーションコードです',
    [tokens.inventory.location_address]: 'ロケーション住所',
    [tokens.inventory.please_scan_moving_location_code_or_barcode]: '移動するロケーションコードまたはバーコードをスキャンして入力してください。',
    [tokens.inventory.same_location_departure_and_arrival]: 'ロケーションの出発地と到着地が同じです。もう一度確認してください。',
    [tokens.inventory.same_center_location]: '同一センター内のロケーションです。もう一度確認してください。',
    [tokens.inventory.complete_stock_movement]: '在庫移動処理が完了しました。',
    [tokens.inventory.are_you_cancel_stock_movement_request]: '在庫移動のリクエストをキャンセルしますか？',
    [tokens.inventory.canceled_stock_movement_request]: '在庫移動のリクエストがキャンセルされました。',
    [tokens.inventory.location_to_move]: '移動するロケーション',
    [tokens.inventory.please_check_again]: 'これで合っているかもう一度確認してください。',
    [tokens.inventory.not_exists_diposal_schedule_stock]: '廃棄予定の商品はありません。',
    [tokens.inventory.disposal_schedule]: '廃棄予定',
    [tokens.inventory.location]: 'ロケーション',
    [tokens.inventory.empty_inventory_supplement_list]: '在庫補充の履歴はありません。',
    [tokens.inventory.label_code]: 'ラベルコード',
    [tokens.inventory.placement_item_count]: '配置商品の個数',
    [tokens.inventory.placement_rate]: '適正率',
    [tokens.inventory.inventory_info]: '在庫情報',
    [tokens.inventory.no_registered_zone_sector_info]: '登録された区画/セクター情報がありません',
    [tokens.inventory.no_location_modification_history]: 'ロケーションの修正履歴がありません',
    [tokens.inventory.select_location_area]: 'ロケーションの区域（エリア）を選択してください',
    [tokens.inventory.select_location_sector]: 'ロケーションのセクターを選択してください',
    [tokens.inventory.select_rack_column_number]: 'ラックの列番号を選択してください',
    [tokens.inventory.select_location_bay]: 'ロケーションのベイを選択してください',
    [tokens.inventory.select_rack_tier]: 'ラックの段数を選択してください',
    [tokens.inventory.select_location_purpose]: 'ロケーションの用途を選択してください',
    [tokens.inventory.select_location_option]: 'ロケーションのオプションを選択してください',
    [tokens.inventory.select_location_temperature]: 'ロケーションの温度を選択してください.',
    [tokens.inventory.confirm_location_modification]: 'ロケーションを修正しますか？',
    [tokens.inventory.location_modified]: 'ロケーションが修正されました',
    [tokens.inventory.no_registered_zone_info]: '登録された区画情報がありません',
    [tokens.inventory.no_registered_sector_info]: '登録されたセクター情報がありません',
    [tokens.inventory.location_label_code]: 'ロケーションラベルコード',
    [tokens.inventory.zone_code]: '区画コード',
    [tokens.inventory.sector_code]: 'セクターコード',
    [tokens.inventory.bay_code]: 'ベイコード',
    [tokens.inventory.rack]: 'ラック',
    [tokens.inventory.rack_code]: 'ラックコード',
    [tokens.inventory.enter_location_zone_name]: 'ロケーションの区画名を入力してください',
    [tokens.inventory.confirm_location_zone_addition]: 'ロケーションの区画を追加しますか？',
    [tokens.inventory.zone_added]: '区画が追加されました',
    [tokens.inventory.location_area_must_be_assigned]: 'ロケーションの区域（エリア）が指定される必要があります。確認してください。',
    [tokens.inventory.enter_location_sector_name]: 'ロケーションのセクター名を入力してください',
    [tokens.inventory.confirm_location_sector_addition]: 'ロケーションのセクターを追加しますか？',
    [tokens.inventory.sector_added]: 'セクターが追加されました',
    [tokens.inventory.no_inventory_items_to_move]: '在庫を移動する商品の情報がありません',
    [tokens.inventory.move_qty]: '移動数量',
    [tokens.inventory.enter_minimum_move_qty_of_1_or_more]: '最小移動数量は1以上で入力してください',
    [tokens.inventory.entered_move_qty_exceeds_movable_qty]: '入力した移動数量が移動可能数量を超えています',
    [tokens.inventory.enter_minimum_return_qty_of_1_or_more]: '最小返品数量は1以上で入力してください',
    [tokens.inventory.no_items_to_return]: '返品する商品の情報がありません',
    [tokens.inventory.return_processed]: '返品処理が完了しました',
    [tokens.inventory.return_qty]: '返品理由',
    [tokens.inventory.return_reason]: '返品理由',
    [tokens.inventory.confirm_adjustment]: '本当に調整しますか？',
    [tokens.inventory.adjust_consumption_deadline_due_to_reason]: '理由で賞味期限を調整します',
    [tokens.inventory.adjust_inventory_qty_due_to_reason]: '理由で在庫数量を増減します',
    [tokens.inventory.decrease_inventory_qty_due_to_reason]: '理由で在庫数量を減らします',
    [tokens.inventory.inventory_adjustment_processed]: '在庫調整処理が完了しました',
    [tokens.inventory.adjustment_type]: '調整タイプ',
    [tokens.inventory.adjustment_qty]: '調整数量',
    [tokens.inventory.enter_minimum_adjustment_qty_of_1_or_more]: '最小調整数量は1以上で入力してください',
    [tokens.inventory.consumption_deadline_required_for_adjustment]: '賞味期限を調整する際、賞味期限の入力は必須です',
    [tokens.inventory.lot_no_required_for_adjustment]: 'LOT番号を調整する場合、LOT番号の入力は必須です。',
    [tokens.inventory.no_items_to_adjust]: '調整する商品の情報がありません',
    [tokens.inventory.location_registration_completed]: 'ロケーションの登録が完了しました',
    [tokens.inventory.confirm_additional_registration]: '追加で登録しますか？',
    [tokens.inventory.confirm_inventory_replenishment_cancellation]: '在庫補充をキャンセルしますか？',
    [tokens.inventory.replenishment_cancellation_successful]: '補充のキャンセルに成功しました',
    [tokens.inventory.location_info]: 'ロケーション情報',
    [tokens.inventory.destination_location]: '到着地ロケーション',
    [tokens.inventory.origin_location]: '出発地ロケーション',
    [tokens.inventory.replenishment_qty]: '補充数量',
    [tokens.inventory.inventory_survey_progress]: '在庫調査の進捗状況',
    [tokens.inventory.inventory_survey_date]: '在庫調査日',
    [tokens.inventory.existing_consumption_deadline]: '既存の賞味期限',
    [tokens.inventory.survey_consumption_deadline]: '調査賞味期限',
    [tokens.inventory.existing_qty]: '既存数量',
    [tokens.inventory.survey_qty]: '調査数量',
    [tokens.inventory.changed_qty]: '変更数量',
    [tokens.inventory.modify_selected_location_info]: '選択したロケーション情報を修正します',

    [tokens.code.brd_stl_stt_cd_ny]: '未確定',
    [tokens.code.brd_stl_stt_cd_cf]: '確定',
    [tokens.code.brd_stl_stt_cd_er]: '精算エラー',
    [tokens.code.brd_stl_typ_cd_dist]: '流通売上',
    [tokens.code.brd_stl_typ_cd_logi]: '物流売上',
    [tokens.code.brd_stl_typ_cd_none]: '精算なし',
    [tokens.code.gd_typ_e]: '専用',
    [tokens.code.gd_typ_g]: '汎用',
    [tokens.code.invn_typ_day]: '日在庫',
    [tokens.code.invn_typ_direct]: '直送',
    [tokens.code.invn_typ_keep]: '保管在庫',
    [tokens.code.gd_tmp_typ_c]: '冷蔵',
    [tokens.code.gd_tmp_typ_f]: '冷凍',
    [tokens.code.gd_tmp_typ_r]: '常温',
    [tokens.code.orgn_typ_d]: '国産',
    [tokens.code.orgn_typ_i]: '輸入品',
    [tokens.code.orgn_typ_o]: 'その他',
    [tokens.code.sls_stt_bfe]: '終了差し迫った',
    [tokens.code.sls_stt_con]: '契約中',
    [tokens.code.sls_stt_end]: '終了',
    [tokens.code.sls_stt_stp]: '利用停止',
    [tokens.code.sls_rtt_asign]: '割当',
    [tokens.code.sls_rtt_unasign]: '未割当',
    [tokens.code.gd_use_typ_end]: '終結',
    [tokens.code.gd_use_typ_unuse]: '未使用',
    [tokens.code.gd_use_typ_use]: '使用',
    [tokens.code.nation_ae]: 'united arab emirates',
    [tokens.code.nation_am]: 'USA',
    [tokens.code.nation_an]: 'Argentina',
    [tokens.code.nation_as]: 'Austria',
    [tokens.code.nation_au]: 'Australia',
    [tokens.code.nation_bg]: 'Belgium',
    [tokens.code.nation_br]: 'Bahrain',
    [tokens.code.nation_bz]: 'Brazil',
    [tokens.code.nation_ca]: 'Canada',
    [tokens.code.nation_cb]: 'Colombia',
    [tokens.code.nation_ch]: 'Chile',
    [tokens.code.nation_cn]: 'China',
    [tokens.code.nation_cr]: 'Costa Rica',
    [tokens.code.nation_dm]: 'Denmark',
    [tokens.code.nation_dn]: 'Dominica',
    [tokens.code.nation_eg]: 'Egypt',
    [tokens.code.nation_etc]: 'Foreign Product',
    [tokens.code.nation_fg]: 'Fiji',
    [tokens.code.nation_fl]: 'Finland',
    [tokens.code.nation_fr]: 'France',
    [tokens.code.nation_gm]: 'Germany',
    [tokens.code.nation_gn]: 'Guinea',
    [tokens.code.nation_gr]: 'Greece',
    [tokens.code.nation_hk]: 'Hong Kong',
    [tokens.code.nation_id]: 'India',
    [tokens.code.nation_idn]: 'Indonesia',
    [tokens.code.nation_il]: 'Ireland',
    [tokens.code.nation_ir]: 'Iran',
    [tokens.code.nation_is]: 'Israel',
    [tokens.code.nation_it]: 'Italy',
    [tokens.code.nation_jp]: 'Japan',
    [tokens.code.nation_mc]: 'Mexico',
    [tokens.code.nation_mgc]: 'Madagascar',
    [tokens.code.nation_mn]: 'Monaco',
    [tokens.code.nation_mr]: 'Morocco',
    [tokens.code.nation_ms]: 'Malaysia',
    [tokens.code.nation_mt]: 'Mauritania',
    [tokens.code.nation_my]: 'Myanmar',
    [tokens.code.nation_nd]: 'Netherlands',
    [tokens.code.nation_ng]: 'Nigeria',
    [tokens.code.nation_nw]: 'Norway',
    [tokens.code.nation_nz]: 'New Zealand',
    [tokens.code.nation_pc]: 'Pakistan',
    [tokens.code.nation_pf]: 'Pacific',
    [tokens.code.nation_pfc]: 'Pacific',
    [tokens.code.nation_pg]: 'Paraguay',
    [tokens.code.nation_pl]: 'Poland',
    [tokens.code.nation_pp]: 'Philippines',
    [tokens.code.nation_pr]: 'Peru',
    [tokens.code.nation_pt]: 'Portugal',
    [tokens.code.nation_rsa]: 'South Africa',
    [tokens.code.nation_ru]: 'Russia',
    [tokens.code.nation_sb]: 'Serbia',
    [tokens.code.nation_sd]: 'Saudi Arabia',
    [tokens.code.nation_sea]: 'Ocean',
    [tokens.code.nation_sg]: 'Senegal',
    [tokens.code.nation_sgp]: 'Singapore',
    [tokens.code.nation_sl]: 'Sri Lanka',
    [tokens.code.nation_sp]: 'Spain',
    [tokens.code.nation_ss]: 'Switzerland',
    [tokens.code.nation_sw]: 'Sweden',
    [tokens.code.nation_tk]: 'Turkey',
    [tokens.code.nation_tl]: 'Thailand',
    [tokens.code.nation_ts]: 'Tunisia',
    [tokens.code.nation_tw]: 'Taiwan',
    [tokens.code.nation_ub]: 'Uzbekistan',
    [tokens.code.nation_uk]: 'United Kingdom',
    [tokens.code.nation_vt]: 'Vietnam',
    [tokens.code.brd_stat_ei]: '終了差し迫った',
    [tokens.code.brd_stat_en]: '終了',
    [tokens.code.brd_stat_st]: 'ノーマル',
    [tokens.code.sls_ctt_postpay]: '後払い',
    [tokens.code.sls_ctt_prepay]: '前払い',
    [tokens.code.pc_grnt_typ_e]: '終了',
    [tokens.code.pc_grnt_typ_i]: '終了差し迫った',
    [tokens.code.pc_grnt_typ_n]: 'ノーマル',
    [tokens.code.pc_grnt_typ_none]: '状態なし',
    [tokens.code.pr_stt_direct]: '自己配送',
    [tokens.code.pr_stt_ic]: '入荷完了',
    [tokens.code.pr_stt_if]: '入庫確認',
    [tokens.code.pr_stt_ik]: '入庫確認',
    [tokens.code.pr_stt_iw]: '入庫待機',
    [tokens.code.pr_stt_pr]: '発注リクエスト',
    [tokens.code.pr_stt_px]: '発注キャンセル',
    [tokens.code.rtrn_prog_ab]: '廃棄処理',
    [tokens.code.rtrn_prog_rx]: '返品キャンセル',
    [tokens.code.rtrn_prog_rr]: '返品受付',
    [tokens.code.rtrn_prog_rc]: '返品リクエスト（確定）',
    [tokens.code.rtrn_typ_bd]: '商品不良',
    [tokens.code.rtrn_typ_bk]: '商品破損',
    [tokens.code.rtrn_typ_sp]: '賞味期限経過',
    [tokens.code.pc_stl_typ_cf]: '確定完了',
    [tokens.code.pc_stl_typ_ny]: '未確定',
    [tokens.code.bond_pay_stt_npaid]: '未払',
    [tokens.code.bond_pay_stt_paid]: '返済済み',
    [tokens.code.crdt_stt_cd_e]: '終了',
    [tokens.code.crdt_stt_cd_n]: '正常',
    [tokens.code.crdt_stt_cd_s]: '停止',
    [tokens.code.adj_price_category_bond_adj]: '債権調整',
    [tokens.code.adj_price_category_claim]: 'クレーム',
    [tokens.code.adj_price_category_coast]: '費用請求',
    [tokens.code.adj_price_category_etc]: 'その他',
    [tokens.code.adj_price_category_purchase]: '仕入費',
    [tokens.code.adj_price_category_quick]: 'クイック費',
    [tokens.code.adj_price_category_quick_purchase]: 'クイック/仕入れ',
    [tokens.code.adj_price_category_sales_adj]: '売上調整',
    [tokens.code.sbjct_rspns_center_mng]: 'センター管理者',
    [tokens.code.sbjct_rspns_consultant]: 'コンサルタント',
    [tokens.code.sbjct_rspns_dlvr_mng]: '配送マネージャー',
    [tokens.code.sbjct_rspns_inbound]: '入庫地センター',
    [tokens.code.sbjct_rspns_logistics]: '物流社',
    [tokens.code.sbjct_rspns_outbound]: '出車地センター',
    [tokens.code.sbjct_rspns_pc_mng]: '購入担当者',
    [tokens.code.sbjct_rspns_purchase]: '仕入れ先',
    [tokens.code.sbjct_rspns_sales]: '売上先',
    [tokens.code.sbjct_rspns_sales_mng]: '営業担当者',
    [tokens.code.sls_stl_typ_cf]: '確定完了',
    [tokens.code.sls_stl_typ_er]: '精算エラー',
    [tokens.code.sls_stl_typ_ff]: '強制確定',
    [tokens.code.sls_stl_typ_ny]: '未確定',
    [tokens.code.pr_stt_direct]: '自社配送',
    [tokens.code.pr_stt_ic]: '入庫完了',
    [tokens.code.pr_stt_if]: '入庫確定',
    [tokens.code.pr_stt_ik]: '入庫確認',
    [tokens.code.pr_stt_iw]: '入庫待機',
    [tokens.code.pr_stt_pr]: '発注リクエスト',
    [tokens.code.pr_stt_px]: '発注キャンセル',
    [tokens.code.po_inb_stt_fi]: '強制入庫',
    [tokens.code.po_inb_stt_mi]: '未入庫',
    [tokens.code.po_inb_stt_ni]: '正常入庫',
    [tokens.code.po_inb_stt_pi]: '部分入庫',
    [tokens.code.rqsts_bad_02]: '商品不良',
    [tokens.code.rqsts_bad_break]: '商品不良破損',
    [tokens.code.rqsts_brk_crm_2]: '破損',
    [tokens.code.rqsts_chn_mind]: '単純な心変わり',
    [tokens.code.rqsts_cop_crm_2]: 'コンピュータに関する問い合わせ',
    [tokens.code.rqsts_cor_dlvr_02]: '対応配送',
    [tokens.code.rqsts_cre_crm_2]: '決済に関する問い合わせ',
    [tokens.code.rqsts_dlvr_crm_2]: '配送に関する問い合わせ',
    [tokens.code.rqsts_dmg_py_2]: '財産破損',
    [tokens.code.rqsts_doc_crm_2]: '書類要求',
    [tokens.code.rqsts_dor_lck_2]: '出入口の未施行',
    [tokens.code.rqsts_err_code_02]: 'エラーコード',
    [tokens.code.rqsts_err_stack_02]: '誤積載',
    [tokens.code.rqsts_error]: '誤配送',
    [tokens.code.rqsts_etc]: 'その他',
    [tokens.code.rqsts_etc_02]: 'その他の問い合わせ',
    [tokens.code.rqsts_expired]: '賞味期限',
    [tokens.code.rqsts_miss]: '未配送',
    [tokens.code.rqsts_no_st_crm2]: '未入庫',
    [tokens.code.rqsts_open_clo_2]: '冷蔵庫の開閉',
    [tokens.code.rqsts_ord_crm_02]: '発注に関する問い合わせ',
    [tokens.code.rqsts_over_st_2]: '過入庫',
    [tokens.code.rqsts_pro_crm_2]: '製品に関する問い合わせ',
    [tokens.code.rqsts_sup_data_02]: '証拠資料',
    [tokens.code.rqsts_unrecover2]: '未回収',
    [tokens.code.rqsts_wrg_ord_2]: '誤発注',
    [tokens.code.rqsts_wrg_sto_2]: '誤入庫',
    [tokens.code.tkbck_prog_tc]: '回収完了',
    [tokens.code.tkbck_prog_tg]: '回収中',
    [tokens.code.tkbck_prog_tx]: '回収キャンセル',
    [tokens.code.tkbck_prcsn_done]: '回収正常終了',
    [tokens.code.tkbck_prcsn_fc]: '完了',
    [tokens.code.tkbck_prcsn_n]: '未処理',
    [tokens.code.tkbck_prcsn_pc]: '部分完了',
    [tokens.code.tkbck_prcsn_r]: '待機中',
    [tokens.code.tkbck_inb_ab]: '廃棄',
    [tokens.code.tkbck_inb_gq]: '良品化',
    [tokens.code.tkbck_inb_qw]: '良品待機',
    [tokens.code.tkbck_inb_ret]: '返品',
    [tokens.code.tkbck_dlv_ab]: '自主廃棄',
    [tokens.code.tkbck_dlv_c]: 'センター回収',
    [tokens.code.mdlml_inb_stt_ic]: '入庫完了',
    [tokens.code.mdlml_inb_stt_in_dlv]: '配送中',
    [tokens.code.mdlml_inb_stt_iw]: '入庫待機',
    [tokens.code.mdlml_inb_stt_prtl_dlv]: '部分配送',
    [tokens.code.mdlml_inb_stt_xi]: '未入庫',
    [tokens.code.ord_prog_dc]: '配送完了',
    [tokens.code.ord_prog_dd]: '配送遅延',
    [tokens.code.ord_prog_dw]: '配送中',
    [tokens.code.ord_prog_oc]: '注文確定',
    [tokens.code.ord_prog_or]: '注文受付',
    [tokens.code.ord_prog_ox]: '注文キャンセル',
    [tokens.code.ord_prog_pd]: '部分配送',
    [tokens.code.ord_cancel_ok]: '正常',
    [tokens.code.ord_cancel_ox]: '全体キャンセル',
    [tokens.code.ord_cancel_pc]: '部分キャンセル',
    [tokens.code.outb_stt_e]: '未出',
    [tokens.code.outb_stt_el]: '未積載',
    [tokens.code.outb_stt_k]: '確認必要',
    [tokens.code.outb_stt_n]: '正常',
    [tokens.code.outb_stt_pd]: '部分配送',
    [tokens.code.outb_stt_q]: '先出庫',
    [tokens.code.outb_stt_ro]: '再出庫',
    [tokens.code.outb_stt_x]: 'キャンセル',
    [tokens.code.outb_typ_emrg]: '緊急出庫',
    [tokens.code.outb_typ_last]: '支線',
    [tokens.code.outb_typ_mid]: '幹線',
    [tokens.code.issu_src_e]: '未出',
    [tokens.code.issu_src_el]: '未積載',
    [tokens.code.issu_src_k]: '要確認',
    [tokens.code.issu_src_n]: '正常',
    [tokens.code.issu_src_pd]: '部分配送',
    [tokens.code.issu_src_q]: '先出庫',
    [tokens.code.issu_src_ro]: '再出庫',
    [tokens.code.issu_src_x]: 'キャンセル',
    [tokens.code.center_issu_e]: '緊急出庫',
    [tokens.code.center_issu_o]: '出庫指示',
    [tokens.code.center_issu_r]: 'リクエストキャンセル',
    [tokens.code.center_issu_ro]: '再出庫指示',
    [tokens.code.center_issu_x]: '注文キャンセル',
    [tokens.code.issu_prcsn_cr]: '顧客リクエスト',
    [tokens.code.issu_prcsn_dd]: '配送遅延',
    [tokens.code.issu_prcsn_et]: 'その他',
    [tokens.code.issu_prcsn_gb]: '商品不良、破損',
    [tokens.code.issu_prcsn_ie]: '在庫不足',
    [tokens.code.invn_adjs_typ_ab]: '廃棄',
    [tokens.code.invn_adjs_typ_defective]: '不良',
    [tokens.code.invn_adjs_typ_los]: '損失処理',
    [tokens.code.invn_adjs_typ_ml]: '未上架',
    [tokens.code.invn_adjs_typ_rcv]: '損失回復',
    [tokens.code.invn_adjs_typ_shl]: '賞味期限調整',
    [tokens.code.invn_adjs_typ_lot]: 'LOT番号修正',
    [tokens.code.invnsu_prog_c]: '完了',
    [tokens.code.invnsu_prog_f]: '確定',
    [tokens.code.invnsu_prog_w]: '進行中',
    [tokens.code.invn_prcsn_ab]: '廃棄',
    [tokens.code.invn_prcsn_ci]: '創刊入庫',
    [tokens.code.invn_prcsn_co]: '創刊出庫',
    [tokens.code.invn_prcsn_defective]: '不良',
    [tokens.code.invn_prcsn_in]: '入庫',
    [tokens.code.invn_prcsn_los]: '損失処理',
    [tokens.code.invn_prcsn_mov]: '移動',
    [tokens.code.invn_prcsn_out]: '出庫',
    [tokens.code.invn_prcsn_rcv]: '損失復旧',
    [tokens.code.invn_prcsn_ret]: '返品',
    [tokens.code.invn_prcsn_shl]: '賞味期限調整',
    [tokens.code.invn_prcsn_tb]: '回収',
    [tokens.code.lct_typ_bd]: '調整ゾーン',
    [tokens.code.lct_typ_db]: '配分ゾーン',
    [tokens.code.lct_typ_et]: 'その他',
    [tokens.code.lct_typ_in]: '入庫ゾーン',
    [tokens.code.lct_typ_jb]: '作業ゾーン',
    [tokens.code.lct_typ_kp]: '保管ゾーン',
    [tokens.code.lct_typ_mv]: '移動ゾーン',
    [tokens.code.lct_typ_ot]: '出庫ゾーン',
    [tokens.code.lct_typ_pk]: 'ピッキングゾーン',
    [tokens.code.lct_typ_rt]: '返品ゾーン',
    [tokens.code.lct_typ_tk]: '回収ゾーン',
    [tokens.code.tm_dlv_stat_dlv_cpl]: '配送完了',
    [tokens.code.tm_dlv_stat_in_dlv]: '配送中',
    [tokens.code.tm_dlv_stat_inb_wait]: '入車待機中',
    [tokens.code.tm_dlv_stat_load_inspc]: '積載検査中',
    [tokens.code.tm_dlv_stat_load_wait]: '積載待機中',
    [tokens.code.dlv_ml_last]: '支線',
    [tokens.code.dlv_ml_mid]: '幹線',
    [tokens.code.tm_biz_type_prsnl]: '個人',
    [tokens.code.tm_biz_type_trnsp]: '運送業者',
    [tokens.code.tm_cntr_stat_cntr_end]: '契約終了',
    [tokens.code.tm_cntr_stat_under_cntr]: '契約中',
    [tokens.code.stlprg_mnt_next_mth]: '翌月',
    [tokens.code.stand_dt_1]: '1',
    [tokens.code.stand_dt_10]: '10',
    [tokens.code.stand_dt_15]: '15',
    [tokens.code.stand_dt_20]: '20',
    [tokens.code.stand_dt_25]: '25',
    [tokens.code.stand_dt_5]: '5',
    [tokens.code.stand_dt_last]: '末日',
    [tokens.code.cnsln_typ_cd_claim]: 'クレーム',
    [tokens.code.cnsln_typ_cd_common]: '一般',
    [tokens.code.cnsln_typ_cd_issue]: '出荷問題',
    [tokens.code.cnsln_typ_cd_msg]: 'メッセージ送信',
    [tokens.code.cnsln_typ_cd_recall]: '返品/交換',
    [tokens.code.cnsln_typ_cd_urgnt_dlvr]: '緊急出荷',
    [tokens.code.crm_gnr_inq_break_crm_01]: '破損',
    [tokens.code.crm_gnr_inq_comp_crm_01]: 'コンピュータ問い合わせ',
    [tokens.code.crm_gnr_inq_cr_dlvr_1]: '対応配送',
    [tokens.code.crm_gnr_inq_cred_crm_01]: '決済問い合わせ',
    [tokens.code.crm_gnr_inq_dlvr_crm_01]: '配送問い合わせ',
    [tokens.code.crm_gnr_inq_dlvr_rt]: '配送 • 回収 問い合わせ',
    [tokens.code.crm_gnr_inq_dmg_py_01]: '再貨破損',
    [tokens.code.crm_gnr_inq_docu_crm_01]: '書類要求',
    [tokens.code.crm_gnr_inq_door_lo_1]: '出入り口未施行',
    [tokens.code.crm_gnr_inq_er_code_1]: 'エラーコード',
    [tokens.code.crm_gnr_inq_err_st_1]: '誤積載',
    [tokens.code.crm_gnr_inq_etc]: 'その他問い合わせ',
    [tokens.code.crm_gnr_inq_etc_01]: 'その他の問い合わせ',
    [tokens.code.crm_gnr_inq_goods_inq]: '商品問い合わせ',
    [tokens.code.crm_gnr_inq_no_st_cr_1]: '未入庫',
    [tokens.code.crm_gnr_inq_open_cl_1]: '冷蔵庫開閉',
    [tokens.code.crm_gnr_inq_ord_crm_01]: '発注問い合わせ',
    [tokens.code.crm_gnr_inq_ord_stl]: '注文 • 精算 問い合わせ',
    [tokens.code.crm_gnr_inq_over_st_1]: '過剰入庫',
    [tokens.code.crm_gnr_inq_prod_crm_01]: '製品問い合わせ',
    [tokens.code.crm_gnr_inq_sup_da_01]: '証明資料',
    [tokens.code.crm_gnr_inq_sys]: 'システム問い合わせ',
    [tokens.code.crm_gnr_inq_unrecover_01]: '未回収',
    [tokens.code.crm_gnr_inq_wng_or_1]: '誤発注',
    [tokens.code.crm_gnr_inq_wng_st_1]: '誤入庫',
    [tokens.code.crm_dtl_ty_bad]: '商品不良',
    [tokens.code.crm_dtl_ty_bad_pack]: '包装不良',
    [tokens.code.crm_dtl_ty_break]: '商品破損',
    [tokens.code.crm_dtl_ty_break_crm]: '破損',
    [tokens.code.crm_dtl_ty_comp_crm]: 'コンピュータ問い合わせ',
    [tokens.code.crm_dtl_ty_cor_dlvr]: '対応配送',
    [tokens.code.crm_dtl_ty_cred_crm]: '決済問い合わせ',
    [tokens.code.crm_dtl_ty_dlvr_crm]: '配送問い合わせ',
    [tokens.code.crm_dtl_ty_dly_dlvr]: '遅延配送',
    [tokens.code.crm_dtl_ty_dmg_pry]: '再貨破損',
    [tokens.code.crm_dtl_ty_docu_crm]: '書類要求',
    [tokens.code.crm_dtl_ty_door_lock]: '出入り口未施行',
    [tokens.code.crm_dtl_ty_err_code]: 'エラーコード',
    [tokens.code.crm_dtl_ty_err_ln_bd]: '与信・債権 エラー',
    [tokens.code.crm_dtl_ty_err_ord]: '注文不可エラー',
    [tokens.code.crm_dtl_ty_err_price]: '精算金額 エラー',
    [tokens.code.crm_dtl_ty_err_recall]: '再回収',
    [tokens.code.crm_dtl_ty_err_stack]: '誤積載',
    [tokens.code.crm_dtl_ty_etc]: 'その他',
    [tokens.code.crm_dtl_ty_expired_dt]: '賞味期限',
    [tokens.code.crm_dtl_ty_misdlvr]: '誤配送',
    [tokens.code.crm_dtl_ty_no_st_cr]: '未入庫',
    [tokens.code.crm_dtl_ty_open_close]: '冷蔵庫開閉',
    [tokens.code.crm_dtl_ty_ord_crm]: '発注問い合わせ',
    [tokens.code.crm_dtl_ty_over_st]: '過剰入庫',
    [tokens.code.crm_dtl_ty_prod_crm]: '製品問い合わせ',
    [tokens.code.crm_dtl_ty_sup_da]: '証明資料',
    [tokens.code.crm_dtl_ty_undlvr]: '未配送',
    [tokens.code.crm_dtl_ty_unrecover]: '未回収',
    [tokens.code.crm_dtl_ty_wrg_ord]: '誤発注',
    [tokens.code.crm_dtl_ty_wrg_st]: '誤入庫',
    [tokens.code.return_stt_cd_approve]: '返品承認',
    [tokens.code.return_stt_cd_receipt]: '受付',
    [tokens.code.return_stt_cd_reject]: '返却',
    [tokens.code.prcsn_stt_cd_done]: '完了',
    [tokens.code.prcsn_stt_cd_incomplete]: '未完了',
    [tokens.code.prcsn_stt_cd_rc]: 'リクエストキャンセル',
    [tokens.code.crm_process_type_e]: '交換',
    [tokens.code.crm_process_type_r]: '返品',
    [tokens.code.crm_type_basc_ask]: '一般問い合わせ',
    [tokens.code.crm_type_break_bad]: '商品破損・不良',
    [tokens.code.crm_type_claim_ask]: 'クレーム',
    [tokens.code.crm_type_dlvr_rt]: '配送・回収',
    [tokens.code.crm_type_etc_ask]: 'その他',
    [tokens.code.crm_type_ord_stl]: '注文・精算',
    [tokens.code.noti_state_noti]: '通知中',
    [tokens.code.noti_state_noti_end]: '通知終了',
    [tokens.code.notice_ctg_brand_cal]: '債権・清算',
    [tokens.code.notice_ctg_etc]: 'その他',
    [tokens.code.notice_ctg_goods]: '商品',
    [tokens.code.notice_ctg_ord_deli]: '注文・配送',
    [tokens.code.notice_ctg_system]: 'システム',
    [tokens.code.grnt_typ_cash]: '現金',
    [tokens.code.grnt_typ_credit]: '信用',
    [tokens.code.grnt_typ_pgrnt]: '履行保証保険',
    [tokens.code.tm_dlv_cpl_stat_dlv_cpl]: '配送完了',
    [tokens.code.tm_dlv_cpl_stat_in_dlv]: '配送中',
    [tokens.code.tm_dlv_cpl_stat_no_dlv]: '未配送',
    [tokens.code.tm_dlv_cpl_stat_prtl_dlv]: '部分配送',
    [tokens.code.bond_typ_cd_adj]: '調整金',
    [tokens.code.bond_typ_cd_en]: '解約',
    [tokens.code.bond_typ_cd_in]: '入金',
    [tokens.code.bond_typ_cd_mig]: '売上移管',
    [tokens.code.bond_typ_cd_out]: '出金',
    [tokens.code.bond_typ_cd_st]: '生成',
    [tokens.code.parcel]: '宅配',
    [tokens.code.truck]: 'トラック',
    [tokens.code.ft20]: '20FT',
    [tokens.code.ft40]: '40FT',
    [tokens.code.invn_mv_typ_c]: '倉庫間移動',
    [tokens.code.invn_mv_typ_m]: '在庫移動',
    [tokens.code.invn_mv_prog_n]: '美的値',
    [tokens.code.invn_mv_prog_c]: '完了',
    [tokens.code.invn_my_prog_x]: 'キャンセル',
    [tokens.code.inb_prog_cd_ie]: '入荷予定',
    [tokens.code.inb_prog_cd_iw]: '入庫待機',
    [tokens.code.inb_prog_cd_uc]: '入庫確認',
    [tokens.code.inb_prog_cd_mi]: '未着',
    [tokens.code.inb_prog_cd_pi]: '一部入荷',
    [tokens.code.inb_prog_cd_ic]: '入荷完了',

    [tokens.error.inbound_mi_error_title]: '未入荷処理エラー',
    [tokens.error.inbound_mi_error_text]: '未入荷処理中にエラーが発生しました。',
    [tokens.error.inbound_lot_error_title]: '商品LOT照会エラー',
    [tokens.error.inbound_lot_error_text]: '商品LOT照会エラーが発生しました。',
    [tokens.error.inbound_lot_save_error_title]: '商品LOT保存エラー',
    [tokens.error.inbound_lot_save_error_text]: '商品LOTエラーが発生しました。',
}
